import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserApiService } from 'src/app/core/api/user.api';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'emp-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, TranslatePipe]
})
export class AccountComponent {
  protected apiService = inject(UserApiService);

  public userInfo$ = this.apiService.getAccountData();
}
